<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <img :src="parkendaValetImage" class="parkendaValetImage" />
      <p class="welcome">{{ this.$store.getters.TRANSLATIONS["welcome"] }}</p>
      <hr class="line" />
      <p class="text1">
        {{ this.$store.getters.TRANSLATIONS["your_car_is_parked"] }}
      </p>
      <p class="text2">
        {{ this.$store.getters.TRANSLATIONS["parking_location"] }}
      </p>
      <hr class="line1" />
      <p class="location-description">{{ parkingLocation }}</p>
      <p class="text2">
        {{ this.$store.getters.TRANSLATIONS["time_entered"] }}
      </p>
      <hr class="line1" />
      <p>
        {{ moment.utc(enterTime).local().format("YYYY-MM-DD HH:mm:ss") }}
      </p>
      <p class="text2">
        {{ this.$store.getters.TRANSLATIONS["your_member_id"] }}
      </p>
      <barcode
        v-model="barcode"
        class="barcode"
        :options="{
          displayValue: true
        }"
      ></barcode>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="requestCar()" class="button">
        {{ this.$store.getters.TRANSLATIONS["request_car"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  beforeCreate() {
    if (this.$route.query.token) {
      this.$storage.set("parkendaToken", this.$route.query.token);
    }
    const timeout = setTimeout(() => {
      this.loading = true;
    }, 0);
    this.$http
      .get(`${process.env.SERVER_URL}/68E437DE09054D61957C712C23FDECD0/0`, {
        headers: {
          "x-access-token": this.$storage.get("parkendaToken")
        }
      })
      .then((response) => {
        console.log("Get last parking response:");
        console.log(response);
        if (response.data) {
          this.$store.dispatch("SAVE_PICKUP_LOCATION", response.data.location);

          response.data.customerId = this.$store.getters.USER.id;
          response.data.flagIsManual =
            response.data.flagIsManual === 0 ? false : true;
          response.data.flagIsExotic =
            response.data.flagIsExotic === 0 ? false : true;
          response.data.flagIfSelfParker =
            response.data.flagIfSelfParker === 0 ? false : true;

          this.$store.dispatch("SAVE_REQUESTED_VEHICLE", response.data);
          this.parkingLocation = response.data.location;
          this.enterTime = response.data.enterTime;
        } else {
          this.$router.push("/parkendaValet");
        }
      })
      .then(() => {
        this.$http
          .get(`${process.env.SERVER_URL}/FA04C1C44AFA43CF9170E1D70335412B`, {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          })
          .then((response) => {
            console.log("Have active parking response");
            console.log(response);
            if (response.data && response.data.haveActiveParking) {
              return;
            } else {
              this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", false);
              this.$router.push("/parkendaValet");
            }
          });
      })
      .then(() => {
        this.$http
          .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          })
          .then((response) => {
            console.log("Get current user response:");
            console.log(response);
            if (response.data) {
              this.$store.dispatch("SAVE_USER", response.data);
              this.barcode = response.data.barcode;
            }
          });
      })
      .catch((error) => {
        this.$storage.remove("parkendaToken");
        // this.$router.push("login");
      })
      .finally(() => {
        clearTimeout(timeout);
        this.loading = false;
      });
  },
  created: function () {
    this.$store.dispatch("TOOLBAR_CLICK_ACTION", 3);
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.barcode = this.$store.getters.USER.barcode;
    }
  },
  data() {
    return {
      loading: true,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642059.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      parkendaValetImage: require("@/assets/new_design/Parkenda_Brandmark.png"),
      menu: require("@/assets/menu.png"),
      menuLogo: require("@/assets/logo.png"),
      open: false,
      parkingLocation: "",
      barcode: null,
      enterTime: "",
      requestType: "PARKENDA",
      requestCar: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/F1366CBBBAB44CACB2197655F39F191F/${this.barcode}/${this.requestType}`,
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Request car response:");
            console.log(response);

            if (response && response.data && response.data.status) {
              switch (response.data.status) {
                case 0:
                  {
                    this.$modal.show("dialog", {
                      text: this.$store.getters.TRANSLATIONS[
                        "vehicle_request_has_failed"
                      ],
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/login");
                          }
                        }
                      ]
                    });
                  }
                  break;
                case 1:
                  {
                    this.$modal.show("dialog", {
                      text: this.$store.getters.TRANSLATIONS[
                        "vehicle_has_been_requested"
                      ],
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/requestInProgress");
                          }
                        }
                      ]
                    });
                  }
                  break;
                case 2:
                  {
                    // this.$modal.show("dialog", {
                    //   text: this.$store.getters.TRANSLATIONS[
                    //     "this_car_is_already"
                    //   ],
                    //   buttons: [
                    //     {
                    //       title: "OK",
                    //       handler: () => {
                    //         this.$router.push("/requestInProgress");
                    //       }
                    //     }
                    //   ]
                    // });
                    this.$router.push("/requestInProgress");
                  }
                  break;
                case 3:
                  {
                    this.$store.dispatch(
                      "SAVE_PARKED_VEHICLES",
                      response.data.vehicles
                    );
                    this.$router.push("/selectCar");
                  }
                  break;
                case 4:
                  {
                    this.$store.dispatch(
                      "SAVE_DROP_OFFS",
                      response.data.dropOffs
                    );
                    this.$router.push("/selectDropOff");
                  }
                  break;
              }
            } else {
              console.log("Request car failed:");
              console.log(response.data);
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["request_car_failed"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$storage.remove("parkendaToken");
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      }
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
.parkendaValetImage {
  display: block;
  width: 28%;
  border-radius: 30px;
  display: block;
  margin: 3vh auto 0;
}
.welcome {
  margin-top: 3px;
  color: #fbae31;
  font-size: 6vw;
  font-family: "BrandonGrotesqueBold";
}
.line {
  background: rgba(114, 174, 255, 1);
  border-color: rgba(114, 174, 255, 1);
  margin: 1vh 17vw;
}
.line1 {
  background: #fbae31;
  border-color: #fbae31;
  margin: 1vh 17vw;
}
.location-description {
  width: 75%;
  margin: 0 auto;
}
.text1 {
  font-family: "BrandonGrotesqueMedium";
  font-size: 4vw;
}
.text2 {
  margin-top: 4vh;
  font-family: "BrandonGrotesqueBold";
  font-size: 5vw;
  color: rgba(114, 174, 255, 1);
}
.barcode {
  width: 60%;
  margin: 5px auto;
  border: 2px solid rgba(114, 174, 255, 1);
  padding: 10px;
  border-radius: 25px;
}
.button {
  margin-top: 20px;
  margin-bottom: 3px;
}
.footer {
  height: 21vh;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/CurrentParking.vue